module.exports = __webpack_public_path__ + "img/Roomin-Logo-White.bc9de8c5.png";